import { Controller } from '@hotwired/stimulus'
import { BrowserQRCodeReader } from '@zxing/library'

const reader = new BrowserQRCodeReader();

export default class extends Controller {
  static targets = ['modal', 'video', 'dismiss']

  scan() {
    // Sets timeout so we don't show the reader loading
    setTimeout(() => {
      this.modalTarget.style.display = 'block'
    }, 2000)

    reader
      .decodeFromInputVideoDevice(undefined, 'video')
      .then((result) => {
        // Add green success border
        this.videoTarget.style.borderColor = '#BDF0A8'
        // Redirect to qr code link
        window.location.href = result.text
      })
      // If we get an error using the reader, close the modal and let the user know
      .catch((err) => {
        console.warn(err)
        // Check we're not just exiting the modal
        if (err.message != 'Video stream has ended before any code could be detected.') {
          this.dismissTarget.click()
          if (err.message == 'Requested device not found') {
            alert('No camera found for the QR code reader.')
          }
          else {
            alert('Sorry, there was an error with the QR code reader.')
          }
        }
      });
  }

  stopScan() {
    // Stops reader and device camera
    this.modalTarget.style.display = 'none'
    reader.reset()
  }
}
